import { DialogMessenger, CallMethodParameters } from './dialogMessenger';
import axios, { AxiosResponse } from 'axios';
import { Environment } from './environment';
import { logSentryError, SentryContext } from 'utils/loggingUtil';

export class WrapperDialogMessenger extends DialogMessenger {

    private authToken: string;
    private callbackRegistrations: { [key: string]: Array<(payload) => any>; } = {};
    constructor() {
        super();
        this.authToken = Environment.getWrapperAuthToken();
        window["__COM_CALLBACK"] = (type, payload) => this.callbackFromCOM(type, payload);

        // Support new edge (webview2)
        // @ts-ignore
        if (window.chrome?.webview?.addEventListener) {
            //@ts-ignore
            window.chrome.webview.addEventListener("message", event => this.callbackFromCOM(event.data.eventType, event.data.payload));
        }
    }

    setData(key: string, message: string) {
        axios({
            url: '/api/data/' + key,
            method: 'POST',
            headers: {
                'Content-Type': 'text/plain',
                'Authorization': `Basic ${this.authToken}`
            },
            data: message
        });
    }


    async getData(key: string): Promise<string> {
        let response = await axios({
            url: '/api/data/' + key,
            method: 'GET',
            headers: {
                'Authorization': `Basic ${this.authToken}`
            }
        });

        return response.data;
    }

    async callAsyncMethod(callParameters: CallMethodParameters, cbk?: (data: any) => void) {
        // One exception that will not be handled via the core: event regstration
        if (callParameters.methodName === 'Office.context.mailbox.addHandlerAsync') {
            const eventType = callParameters.args[0];
            const handler = callParameters.args[1];

            if (!this.callbackRegistrations[eventType])
                this.callbackRegistrations[eventType] = [];

            this.callbackRegistrations[eventType].push(handler);
            return;
        }

        // Normalize method name to url path, to allow using different controllers to handle
        // stuff
        let relativePath = callParameters.methodName.toLowerCase().replace(/\./g, "/");
        let absolutePath = '/api/' + relativePath;

        // Get the data from the VSTA addin via AJAX call (to localhost)
        let response: AxiosResponse<any>;
        try {
            response = await axios({
                url: absolutePath,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${this.authToken}`
                },
                data: JSON.stringify(callParameters.args)
            });
        }
        catch (error) {
            if (cbk) {
                cbk({
                    status: Office.AsyncResultStatus.Failed,
                    error: error
                });
            }
            return;
        }

        if (cbk) {
            let data = response.data;
            if (data.status === Office.AsyncResultStatus.Succeeded && data.value && data.value.__type === "OfficeDialog") {
                // So this is technically making things a bit easy, since it completly ignores the id of
                // the child dialog. So in case we could have more than one open dialog from displayDialogAsync
                // this would actually break here. As this is not possible however, just k.i.s.s. :-*
                data.value.addEventHandler = (type: Office.EventType, eventHandler: (payload) => void) => {
                    if (!this.callbackRegistrations[type])
                        this.callbackRegistrations[type] = [];

                    this.callbackRegistrations[type].push(eventHandler);
                };

                data.value.close = () => {
                    return this.callAsyncMethod({
                        methodName: "Office.context.ui.closeChildDialog",
                        args: [data.value.id]
                    });
                };
            }

            cbk(data);
        }
    }

    callbackFromCOM(type: Office.EventType, payload) {
        if (this.callbackRegistrations[type]) {
            for (const handler of this.callbackRegistrations[type]) {
                // We can't really do this mapping anywhere else, as InvokeScript on C# side does only
                // support strings..
                if (type === Office.EventType.DialogMessageReceived) {
                    handler({
                        message: payload
                    });
                } else if (type === Office.EventType.ItemChanged) {

                    let newItem = null;

                    try {
                        newItem = JSON.parse(payload);
                    } catch (e) {
                        logSentryError(e, SentryContext.evaluation, { message: "Failed to parse newItem", payload: payload });
                    }

                    //as newItem is not processed in the handler, pass null, if parse fails
                    handler(newItem);
                } else {
                    handler(payload);
                }
            }
        }
    }

    getName(): string {
        return "COM Messenger";
    }

    cleanup() {
        // n/a
    }
}
